import { PalletsCell, WeightCell } from 'utils/format';
import { t_stop } from './constants';
import { IS_TENANT } from 'tenant/config';

const LoadRow = ({ load } = {}) => {
  if (!load) {
    return null;
  }
  return (
    <div>
      {t_stop.load}:{' '}
      <PalletsCell
        realPallets={load.number_of_items}
        typePallets={load.pallet_type}
        loadTypes={load.load_type}
        withEquivalents={false}
        stops={load}
      />
      ,
      {load.pallet_type === 'CUSTOM_PALLET' && !IS_TENANT && (
        <>
          {' '}
          ({load.item_width} × {load.item_length}),
        </>
      )}{' '}
      <WeightCell weight={load.total_weight} />
    </div>
  );
};

export default LoadRow;
